import React from 'react';
import EmployeeContainer from '../../containers/employeemng/EmployeeContainer';

const EmployeeViewPage = () => {
  return <EmployeeContainer/>
};

export default EmployeeViewPage;
